export default "/images/vendor/flag-icon-css/flags/1x1/jm.svg?259baa445256a0bc926e973df1505e43";